import { cn } from '@core/utils';
import type { FunctionComponent, SVGProps } from 'react';

import styles from './Svg.module.scss';
import type { SvgComponentProps } from './SvgComponentProps';

export const createSvgComponent =
  (Svg: FunctionComponent<SVGProps<SVGSVGElement>>) =>
  // eslint-disable-next-line react/display-name
  ({ className, originalFill, ...restProps }: SvgComponentProps) => (
    <Svg
      {...restProps}
      className={cn(
        'size-24',
        {
          [styles.icon]: !originalFill,
        },
        className,
      )}
    />
  );
